<div class="isf-batch-wrapper">
  <document-upload-placeholder
    header="UPLOAD_YOUR_ERP_REPORT"
    headerUploaded="ERP_REPORT"
    (upload)="onUploadFile($event)"
    (remove)="onRemoveFile()"
  ></document-upload-placeholder>

  <div class="isf-batch-checkbox">
    <div class="form-group">
      <div class="custom-control custom-checkbox">
        <input type="checkbox" class="custom-control-input" id="auto-confirm" [formControl]="autoConfirmFc" />
        <label class="custom-control-label lcl-booking-hazard-disclaimer-label" for="auto-confirm">
          {{ "AUTOMATICALLY_CONFIRM_FILING" | translate }}
        </label>
      </div>
    </div>
  </div>

  <div class="isf-batch-button">
    <button type="button" class="btn btn-primary" *ngIf="!!uploadedFile" (click)="create()">{{ "BUTTON.CREATE" | translate }}</button>
  </div>

  <div class="isf-batch-template">
    <div class="isf-batch-template-text">
      <div class="isf-batch-template-text-header">{{ "DOWNLOAD_SAMPLE_BLANK" | translate }}</div>
      <div class="isf-batch-template-text-hint">{{ "DOWNLOAD_SAMPLE_BLANK_HINT_ERP" | translate }}</div>
    </div>
    <div class="isf-batch-template-link">
      <div class="isf-batch-template-link-download" (click)="downloadSample()">
        <img alt="download" src="/assets/icons/icon_download_sm_blue.svg" class="ml-2" />
        <span>{{ "BUTTON.DOWNLOAD" | translate }}</span>
      </div>
    </div>
  </div>

  <a #link class="d-none" download></a>
</div>

<loading-spinner [show]="isLoading"></loading-spinner>
